import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion";

export default function CtaBand({
  heading = <>Ready to take your<br /> career <span className="text-[#2FA86A]">seriously?</span></>,
  subtitle = "Book a free 30-minute discovery call. We'll map out your next move, recommend the right service, and give you a clear plan — no pressure, no pitch.",
  showServicesLink = true,
}) {
  return (
    <section data-testid="cta-band" className="bg-white py-8">
      <div className="nc-container">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-[#142A5E] px-8 py-16 md:px-16 md:py-24 grain">
          <div className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full bg-[#2FA86A]/25 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-10 h-72 w-72 rounded-full bg-white/5 blur-3xl" />
          <div className="relative max-w-2xl">
            <Reveal>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.1] text-white">
                {heading}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg text-white/70 max-w-lg">
                {subtitle}
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-9 flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact"
                  data-testid="cta-contact"
                  className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#2FA86A] px-7 py-4 font-semibold text-white transition-colors hover:bg-[#248a5a]"
                >
                  Book a Free Discovery Call
                  <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
                {showServicesLink && (
                  <Link
                    to="/services"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-7 py-4 font-semibold text-white transition-colors hover:bg-white/10"
                  >
                    See All Services
                  </Link>
                )}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
